import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class ClientEntityTypeLookup extends ModelBase {
    public clientEntityTypeId: number = 0;

    public clientEntityTypeName: string = "";
}